import * as React from 'react'

function SvgMedicalHistory(props, svgRef) {
  return (
    <svg viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M3.75 15.313V3.75H.937A.937.937 0 000 4.688v14.375A.938.938 0 00.938 20h10.624a.938.938 0 00.938-.938V17.5H5.937a2.19 2.19 0 01-2.187-2.188zm8.75-11.25V0H5.937A.937.937 0 005 .938v14.375a.937.937 0 00.938.937h10.625a.938.938 0 00.937-.938V5h-4.063a.94.94 0 01-.937-.938zm2.5 5v1.874a.313.313 0 01-.313.313H12.5v2.188a.313.313 0 01-.313.312h-1.874a.313.313 0 01-.313-.313V11.25H7.812a.312.312 0 01-.312-.313V9.063a.312.312 0 01.313-.313H10V6.562a.313.313 0 01.313-.312h1.874a.313.313 0 01.313.313V8.75h2.188a.313.313 0 01.312.313zm2.227-6.211L14.648.273A.936.936 0 0013.984 0h-.234v3.75h3.75v-.237a.937.937 0 00-.273-.661z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgMedicalHistory)
export default ForwardRef
